// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__26OaC","label":"Section_label__2qtQs","contentWrap":"Section_contentWrap__c1Gpm","footer":"Section_footer__1Cr4h","footerInner":"Section_footerInner__1Sbcv"};